function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { Button } from 'swag-client-common/components/ui/button/index';
import { withStyles } from '@material-ui/core/styles';
import { DEFAULT_BUTTON } from '../../../../constants/styles';
import { Contacts } from './components/contacts/contacts-other';
import CSSclasses from './advice-banner.scss';
const styles = {
  button: _objectSpread({}, DEFAULT_BUTTON, {
    padding: '8px 16px',
    margin: '20px 0 0 0'
  })
};
const AdviceBanner = ({
  onChatClick,
  isBoxesPage,
  currentCategoryName,
  isFullRangeButtonHidden,
  fullProductsListLabel,
  fullProductsListLink,
  onFullProductsLinkClick,
  isAdviceBannerShow,
  contacts,
  classes,
  isFilterOpened
}) => {
  const renderWithFullRangeButtonText = () => /*#__PURE__*/React.createElement("span", null, ". To view more products in this category,", /*#__PURE__*/React.createElement("br", null), "click on the view our full range of\xA0", currentCategoryName && currentCategoryName.toLowerCase(), " button above.");
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSclasses.adviceBannerContainer, {
      [CSSclasses.isHidden]: !isAdviceBannerShow,
      [CSSclasses.lessHeight]: isFullRangeButtonHidden,
      [CSSclasses.openedFilter]: isFilterOpened && !isBoxesPage,
      [CSSclasses.boxesPageContainer]: isBoxesPage
    })
  }, !isFullRangeButtonHidden && !isBoxesPage && /*#__PURE__*/React.createElement(Link, {
    className: CSSclasses.link,
    onClick: onFullProductsLinkClick,
    to: fullProductsListLink
  }, /*#__PURE__*/React.createElement(Button, {
    className: CSSclasses.button,
    type: "primary"
  }, fullProductsListLabel)), /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.adviceBannerText
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.title
  }, isBoxesPage ? 'Request a custom package' : "Don't see what you're looking for?"), /*#__PURE__*/React.createElement("span", {
    className: CSSclasses.subtitle
  }, /*#__PURE__*/React.createElement(Contacts, {
    contacts: contacts,
    isBoxesPage: isBoxesPage,
    classes: classes,
    onChatClick: onChatClick
  }), !isBoxesPage && (isFullRangeButtonHidden ? ', or search above.' : renderWithFullRangeButtonText()))));
};
export default withStyles(styles)(AdviceBanner);